/**
 * Cookie Consent Version Constant
 *
 * Single source of truth for the active consent version that the
 * framework-agnostic consent core compares the stored cookie value against.
 *
 * Contract: the version lives in exactly two app-side homes — this file and
 * `ConsentLog::CURRENT_VERSION` in `source/active_snap/app/models/consent_log.rb`
 * — and the two MUST match. Every other reader (including
 * `e2e/playwright/support/on-rails.ts`) imports one of them instead of
 * repeating the literal. The website's `lib/consent-version.ts` must carry the
 * same value so a cookie written on either subdomain parses on the other.
 * Bumping this value re-prompts every browser the next time the consent core
 * runs: the state carries `pendingSource: version_bump_reprompt`, and the
 * resulting row records the banner action's own source.
 */
export const CONSENT_VERSION = "2026-10-16-v1";
